import { axios } from "utils";

import { ADMIN_METHODS_URL as endpoint } from "consts";

export const getAllAdminMethods = async (data) => axios.get(`${endpoint}`, { data });

export const addMethod = async (data) => axios.post(`${endpoint}`, { data });

export const getAdminMethod = async (data) => axios.get(`${endpoint}/${data.id}`, { data });

export const updateMethod = async (data) => axios.put(`${endpoint}/${data.id}`, { data });

export const getFundingOpportunities = async (data) => axios.get(`${endpoint}/funding-opportunities`, { data });

export const addFundingOpportunity = async (data) => axios.post(`${endpoint}/funding-opportunities`, { data });

export const getFundingOpportunity = async (data) => axios.get(`${endpoint}/funding-opportunities/${data.id}`, { data });

export const updateFundingOpportunity = async (data) => axios.put(`${endpoint}/funding-opportunities/${data.id}`, { data });
